import axios from 'axios'
import {
  axiosHrClient,
  axiosReqCardClient,
  axiosReqCerClient,
  axiosNotiClient,
  axiosReqCardClient60s
} from '../plugins/axios'

const auth = {
  namespaced: true,

  state: {
    emailCMU: null,
    firstNameTha: null,
    middleNameTha: null,
    lastNameTha: null,
    firstNameEng: null,
    middleNameEng: null,
    lastNameEng: null,
    picEmpPath: null,
    employeeID: null,
    positionName: null
  },

  mutations: {
    SET_EMP_INFO(state, payload) {
      for (const key in state) {
        state[key] = payload[key] ? payload[key] : null
      }
    }
  },

  actions: {
    getEmpInfo() {
      return new Promise(async (resolve, reject) => {
        try {
          axiosHrClient.defaults.baseURL = await 'https://mis-api.cmu.ac.th/hr/dev/v1'
          axiosReqCardClient.defaults.baseURL = await 'https://mis-api.cmu.ac.th/reqcard/dev/v1'
          axiosReqCardClient60s.defaults.baseURL = await 'https://mis-api.cmu.ac.th/reqcard/dev/v1'
          axiosReqCerClient.defaults.baseURL = await 'https://mis-api.cmu.ac.th/reqcert/dev/v1'
          axiosNotiClient.defaults.baseURL = await 'https://mis-api.cmu.ac.th/noti/dev/v1'
          const res = await axiosHrClient.get('/employees/working')
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getOAuthInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          axiosHrClient.defaults.baseURL = await 'https://mis-api.cmu.ac.th/hr/uat/v1'
          axiosReqCardClient.defaults.baseURL = await 'https://mis-api.cmu.ac.th/reqcard/uat/v1'
          axiosReqCardClient60s.defaults.baseURL = await 'https://mis-api.cmu.ac.th/reqcard/uat/v1'
          axiosReqCerClient.defaults.baseURL = await 'https://mis-api.cmu.ac.th/reqcert/uat/v1'
          axiosNotiClient.defaults.baseURL = await 'https://mis-api.cmu.ac.th/noti/uat/v1'
          const res = await axios.get(
            'https://mis-api.cmu.ac.th/hr/uat/callback?code=' + payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getProdOAuthInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          axiosHrClient.defaults.baseURL = await 'https://api.cmu.ac.th/mis/hrportal/prod/api/v1'
          axiosReqCardClient.defaults.baseURL = await 'https://api.cmu.ac.th/mis/hrreqcard/prod/v1'
          axiosReqCardClient60s.defaults.baseURL = await 'https://api.cmu.ac.th/mis/hrreqcard/prod/v1'
          axiosReqCerClient.defaults.baseURL = await 'https://api.cmu.ac.th/mis/hrreqcert/prod/v1'
          axiosNotiClient.defaults.baseURL = await 'https://api.cmu.ac.th/mis/hrnoti/prod/v1'

          const res = await axios.get(
            'https://api.cmu.ac.th/mis/hrportal/prod/callback?code=' + payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getMobileOAuthInfo(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          axiosHrClient.defaults.baseURL = await 'https://api.cmu.ac.th/mis/hrportal/prod/api/v1'
          axiosReqCardClient.defaults.baseURL = await 'https://api.cmu.ac.th/mis/hrreqcard/prod/v1'
          axiosReqCardClient60s.defaults.baseURL = await 'https://api.cmu.ac.th/mis/hrreqcard/prod/v1'
          axiosReqCerClient.defaults.baseURL = await 'https://api.cmu.ac.th/mis/hrreqcert/prod/v1'
          const res = await axios.get(
            'https://api.cmu.ac.th/mis/hrportal/prod/api/mobilecallback?code=' +
              payload
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    },

    getLineNoti(ctx, payload) {
      return new Promise(async (resolve, reject) => {
        try {
          let endpoint = localStorage.getItem('endpointChannel').split('/')
          const res = await axios.get(
            'https://mis-api.cmu.ac.th/noti/' +
              endpoint[1] +
              '/linecallback?code=' +
              payload,
            {
              headers: {
                Authorization: 'Bearer ' + localStorage.getItem('accesstoken')
              }
            }
          )
          resolve(res)
        } catch (e) {
          reject(e)
        }
      })
    }
  }
}

export default auth
